"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import UiDialog from "../../../../components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { AccountSessionMixins } from "@/service/account-session";
import UiSubmit from "@/components/form/UiSubmit.vue";
import Question from "@/components/Question.vue";
export class EditPowerController extends UiFormController {
  constructor() {
    super(...arguments);
    this.user_guids = [];
    this.powers = [];
  }
}
let EditSubAccountPower = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.formcontroller = new EditPowerController();
    this.shop_powers = [
      {
        key: "SHOP_CREATE",
        name: this.$t("team_management.other_way.dialog.shop_create")
      },
      {
        key: "SHOP_EDIT",
        name: this.$t("team_management.action_power.shop_edit")
      },
      {
        key: "SELECT_SHOP_PASSWORD",
        name: this.$t("team_management.other_way.dialog.select_shop_password")
      },
      {
        key: "DELETE_CACHE",
        name: this.$t("team_management.other_way.dialog.delete_save")
      },
      {
        key: "VIDEO_AUTH",
        name: this.$t("team_management.action_power.dialog.add_video")
      },
      {
        key: "COOKIE_BACKUP",
        name: this.$t("team_management.other_way.dialog.cookie_backup")
      },
      {
        key: "SHOW_LAST_LOGIN",
        name: this.$t("team_management.other_way.dialog.show_last_login")
      },
      {
        key: "SHOW_SHOP_AUTH_COUNT",
        name: this.$t("team_management.other_way.dialog.show_shop_auth_count")
      },
      {
        // cookie导入权限
        key: "IMPORT_COOKIE",
        name: this.$t("team_management.other_way.dialog.cookie_import_power")
      },
      {
        key: "VD_NAME_INVISIBLE",
        name: this.$t("team_management.other_way.dialog.not_vd_name_invisible"),
        question: this.$t(
          "team_management.other_way.dialog.vd_name_invisible_question"
        )
      },
      // {
      //   key: "VD_LIST_MODE_INVISIBLE",
      //   name: this.$t("team_management.other_way.dialog.vd_list_mode"),
      // },
      {
        key: "NOT_VD_LIST_MODE_INVISIBLE",
        name: this.$t("team_management.other_way.dialog.not_vd_list_mode"),
        question: this.$t(
          "team_management.other_way.dialog.not_vd_list_mode_question"
        )
      },
      {
        key: "PLUG_MANAGEMENT_PERSON",
        name: this.$t("team_management.action_power.dialog.extensions_install"),
        question: this.$t(
          "team_management.action_power.dialog.extensions_install_question"
        )
      },
      {
        key: "PLUG_MANAGEMENT",
        name: this.$t("team_management.action_power.dialog.extensions_manager"),
        question: this.$t(
          "team_management.action_power.dialog.extensions_manager_question"
        )
      }
    ];
    this.team_powers = [
      // {
      //   key: "FORBIDDEN_AUTH_VD_MANAGER",
      //   name: this.$t(
      //     "team_management.other_way.dialog.forbidden_auth_vd_manager"
      //   ),
      // },
      {
        key: "NOT_FORBIDDEN_AUTH_VD_MANAGER",
        name: this.$t(
          "team_management.other_way.dialog.not_forbidden_auth_vd_manager"
        ),
        question: this.$t(
          "team_management.other_way.dialog.not_forbidden_auth_vd_manager_question"
        )
      },
      // {
      // key: "ADMIN_DISALLOW_MODIFY_SELF_POWER",
      // name: this.$t(
      //   "team_management.other_way.dialog.admin_disallow_modify_self_power"
      // ),
      // },
      // {
      //   key: "NOT_ADMIN_DISALLOW_MODIFY_SELF_POWER",
      //   name: this.$t(
      //     "team_management.other_way.dialog.not_admin_disallow_modify_self_power"
      //   ),
      //   question: this.$t(
      //     "team_management.other_way.dialog.not_admin_disallow_modify_self_power_question"
      //   ),
      // },
      {
        key: "PASSWORD_EDIT",
        name: this.$t("team_management.other_way.dialog.allow_edit")
      },
      {
        key: "TEAM_LOGIN_SETTING",
        name: this.$t("team_management.other_way.dialog.show_team_login")
      },
      {
        key: "TEAM_LOGIN_APPROVAL",
        name: this.$t("team_management.other_way.dialog.team_login_management")
      },
      {
        key: "ACCESS_CONTROL_SETTING",
        name: this.$t("team_management.other_way.dialog.setting_access_control")
      },
      {
        key: "ACCESS_CONTROL_APPROVAL",
        name: this.$t("team_management.other_way.dialog.access_control_approval")
      },
      {
        key: "IN_PROCESS_MONITORING_SETTING",
        name: this.$t(
          "team_management.other_way.dialog.inprogress_supervision_setting"
        )
      },
      {
        key: "IN_PROCESS_MONITORING_APPROVAL",
        name: this.$t(
          "team_management.other_way.dialog.inprogress_supervision_approval"
        )
      }
    ];
    this.cost_powers = [
      {
        key: "VD_NEW",
        name: this.$t("team_management.other_way.dialog.vd_new")
      },
      {
        key: "VD_RENEW",
        name: this.$t("team_management.other_way.dialog.vd_renew")
      },
      {
        key: "RECHARGE_COIN",
        name: this.$t("team_management.other_way.dialog.recharge_coin_power")
      },
      {
        key: "COIN_DETAIL",
        name: this.$t("team_management.other_way.dialog.coin_info")
      },
      {
        key: "VIEW_ORDER_DETAIL",
        name: this.$t("team_management.other_way.dialog.view_order_detail")
      },
      {
        key: "VD_UPGRADE",
        name: this.$t("team_management.other_way.dialog.vd_upgrade")
      },
      {
        key: "INVOICE_MANAGEMENT",
        name: this.$t("team_management.other_way.dialog.invoice_management")
      }
    ];
    this.service_powers = [
      {
        key: "OPEN_API",
        name: this.$t("team_management.action_power.open_api")
      }
    ];
    this.guids = [];
  }
  open(data) {
    return __async(this, null, function* () {
      try {
        let guids = [];
        for (let item of data) {
          guids.push(item.guid);
        }
        this.guids = guids;
        if (data.length === 1) {
          let response = yield API.get(
            `api://base.auth/api/v8/users/${data[0].guid}`
          );
          let keys = [];
          for (let key of response.data.powers) {
            keys.push(key);
          }
          this.formcontroller.powers = keys;
          if (!this.formcontroller.powers.includes("VD_LIST_MODE_INVISIBLE")) {
            this.formcontroller.powers.push("NOT_VD_LIST_MODE_INVISIBLE");
          }
          if (!this.formcontroller.powers.includes("FORBIDDEN_AUTH_VD_MANAGER") && response.data.role.indexOf("admin") !== -1) {
            this.formcontroller.powers.push("NOT_FORBIDDEN_AUTH_VD_MANAGER");
          }
        }
        if (data.length > 1) {
          this.formcontroller.powers = [];
        }
        this._power_dialog.show();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        if (!this.formcontroller.powers.includes("NOT_VD_LIST_MODE_INVISIBLE")) {
          if (!this.formcontroller.powers.includes("VD_LIST_MODE_INVISIBLE")) {
            this.formcontroller.powers.push("VD_LIST_MODE_INVISIBLE");
          }
        } else {
          this.formcontroller.powers = this.formcontroller.powers.filter((power) => power !== "VD_LIST_MODE_INVISIBLE");
          this.formcontroller.powers = this.formcontroller.powers.filter((power) => power !== "NOT_VD_LIST_MODE_INVISIBLE");
        }
        if (!this.formcontroller.powers.includes("NOT_FORBIDDEN_AUTH_VD_MANAGER")) {
          if (!this.formcontroller.powers.includes("FORBIDDEN_AUTH_VD_MANAGER")) {
            this.formcontroller.powers.push("FORBIDDEN_AUTH_VD_MANAGER");
          }
        } else {
          this.formcontroller.powers = this.formcontroller.powers.filter((power) => power !== "FORBIDDEN_AUTH_VD_MANAGER");
          this.formcontroller.powers = this.formcontroller.powers.filter((power) => power !== "NOT_FORBIDDEN_AUTH_VD_MANAGER");
        }
        let submit = yield API.post(
          `api://base.auth/api/v7/accounts/user_power`,
          {
            powers: this.formcontroller.powers,
            user_guids: this.guids
          }
        );
        this.$message.success(
          this.$t("team_management.action_power.dialog.success_message")
        );
        this._power_dialog.hide();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("power-dialog")
], EditSubAccountPower.prototype, "_power_dialog", 2);
EditSubAccountPower = __decorateClass([
  Component({
    components: {
      UiSubmit,
      UiDialog,
      UiForm,
      Question
    }
  })
], EditSubAccountPower);
export {
  EditSubAccountPower as default
};
